/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1ResultIDs } from '../models/V1ResultIDs';
import { HttpFile } from '../http/http';

export class V1SubDetails {
    /**
    * Total number of result objects
    */
    'resultsCount'?: number;
    'ids'?: V1ResultIDs;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "resultsCount",
            "baseName": "results_count",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "ids",
            "baseName": "ids",
            "type": "V1ResultIDs",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1SubDetails.attributeTypeMap;
    }

    public constructor() {
    }
}

